import { useTranslator, useAppContext } from '@front-activerse/common-components';
import { Link } from 'react-router-dom';

const ShoppingTipsAlert = ({ shoppingTipsArticleId }) => {
  const { t } = useTranslator();
  const {
    images: { handdrawnIcon },
  } = useAppContext();

  return (
    <div className="shopping-tips-alert">
      <h3>
        <img src={handdrawnIcon} style={{ width: '24px' }} className="me-s" alt="" />
        {t('shoppingList.tipBox.title')}
      </h3>
      <ul>
        <li className="mb-m">{t('shoppingList.tipBox.contentPoint1')}</li>
        <li className="mb-m">{t('shoppingList.tipBox.contentPoint2')}</li>
      </ul>
      <Link to={`/knowledge/${shoppingTipsArticleId}`} className="semi-bold">
        {t('shoppingList.tipBox.button')}
      </Link>
    </div>
  );
};

export default ShoppingTipsAlert;
